import { openImagePromptAndInsert } from 'proseShared/prompts/MediaUploadPrompt/MediaUploadPrompt'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'
import { useModals } from 'almanac-ui/Modal'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { processSelectedImages, insertImageIntoDoc } from 'components/ImageMenu/utils'
import { ImageMenuSelectedImage } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'
import { ACCEPTED_IMAGE_MIME_TYPES_NO_SVG } from 'screens/Finder/components/views/GalleryView/constants'

export const InsertImageButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const stackManager = useModals()
  const isNewImageMenuEnabled = useFlipperFlag('new_image_menu')

  const openPrompt = () => {
    if (isNewImageMenuEnabled) {
      stackManager.openModal(ImageMenuModal, {
        accept: ACCEPTED_IMAGE_MIME_TYPES_NO_SVG,
        hiddenProviders: ['stockVideo'],
        onUse: async (images: ImageMenuSelectedImage[]) => {
          const processedImages = await processSelectedImages(images, { showProcessingToast: true })

          processedImages.forEach((image) => {
            if (!image) return

            insertImageIntoDoc(image, view)
          })
          stackManager.closeModal()
        },
        maxCount: Infinity,
        title: 'Insert Image',
      })
    } else {
      openImagePromptAndInsert({ view, stackManager })
    }
    dropdownStore?.hardClose()
  }

  return (
    <SingleMenuDropdownItem icon={<ToolbarIcon name={IconName.ImageAdd} />} label="Image" handleClick={openPrompt} />
  )
}
